import {axiosInstanceWithToken}  from "../utils/Client";

export default class StaffDataService {
    static getUserList = (locationId, allLocation=1) => {
        return axiosInstanceWithToken.get(
            `staff/list_with_correction_pending/${locationId}/?all_location=${allLocation}`
        );
    };

    static getUserListToSendMesasage = () => {
        return axiosInstanceWithToken.get(`/user/`);
    };

    static getStaffKPIAll = (userId) => {
        return axiosInstanceWithToken.get(`/compensation_kpi/all/${userId}/`);
    };

    static getStaffCompKPI = (profileId) => {
        return axiosInstanceWithToken.get(`/compensation_kpi/compensation/${profileId}/`);
    };

    // Get achievements for a kpi assigned to a user
    static getAchievementList = (
            userId, compId, kpiId, startDate, endDate, searchString, statusAll, 
            adminAchievementFilter, page=1
    ) => {
        if (typeof searchString === "undefined") {
            searchString = '';
        }
        adminAchievementFilter = Number(adminAchievementFilter);
        let url = `/achievements/user/${userId}/kpi/${kpiId}/?all=${statusAll}&comp_id=${compId}`;
        url += `&search_string=${searchString}&admin_achievement=${adminAchievementFilter}&page=${page}`
        if(typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        return axiosInstanceWithToken.get(url);
    };

    // Add new achievement
    static postAchievement = (achievementData) => {
        return axiosInstanceWithToken.post(`/staff_data/`, achievementData);
    };

    // get an achievement
    static getAchievement = (achievementId, locationId) => {
        return axiosInstanceWithToken.get(`/staff_data/${locationId}/id/${achievementId}/`);
    };

    // Edit an achievement
    static putAchievement = (achievementId, achievementData, locationId) => {
        return axiosInstanceWithToken.put(
            `/staff_data/${locationId}/id/${achievementId}/`, achievementData,
        );
    };

    // Delete an achievement
    static deleteAchievement = (achievementId, locationId) => {
        return axiosInstanceWithToken.delete(`/staff_data/${locationId}/id/${achievementId}/`);
    };

    // Get correction request list of a user
    static getCorrections = (userId) => {
        return axiosInstanceWithToken.get(`/staff_data/requests/${userId}/`);
    };

    // Approve correction request
    static approveCorrections = (userId, requestId, requestData) => {
        return axiosInstanceWithToken.put(
            `/staff_data/${userId}/correction/${requestId}/`, requestData,
        );
    };

    // Delete correction request
    static deleteCorrectionRequest = (userId, requestId) => {
        return axiosInstanceWithToken.delete(
            `/staff_data/${userId}/correction/${requestId}/`,
        );
    };

    // Generate and download achievements report pdf 
    static getAchievementsPDF = (
        userId, compId, kpiId, startDate, endDate, searchString, 
        statusAll, adminAchievementFilter
    ) => {
        if (typeof searchString === "undefined") {
            searchString = '';
        }
        adminAchievementFilter = Number(adminAchievementFilter);
        let url = `/achievements/report/${userId}/kpi/${kpiId}/?all=${statusAll}&comp_id=${compId}`;
        url += `&search_string=${searchString}&admin_achievement=${adminAchievementFilter}`;
        if(typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        return axiosInstanceWithToken.get(url);
    };

    // Get login log
    static getLoginLog = (userId, startDate, endDate, page=1) => {
        let url = `/login_log/${userId}/?all=1&page=${page}`;

        if(typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        return axiosInstanceWithToken.get(url);
    };

    // Generate and download login log pdf 
    static getLoginLogPDF = (userId, startDate, endDate, location=0, all=0) => {
        let url = `/login_log/report/${userId}/?all=${all}`;

        if(startDate && typeof startDate !== "undefined" && startDate !== "Invalid date") {
            url += `&start_date=${startDate}`;
        }

        if(endDate && typeof endDate !== "undefined" && endDate !== "Invalid date") {
            url += `&end_date=${endDate}`;
        }

        if (location) {
            url += `&agency_location=${location}`
        }

        return axiosInstanceWithToken.get(url);
    };

    // Get Message Item list of a location
    static getMessageList = (locationId) => {
        return axiosInstanceWithToken.get(`/message/list/${locationId}/`);
    };

    // Get Message Item list of a location
    static postMessageItem = (locationId, messageData) => {
        return axiosInstanceWithToken.post(`/message/list/${locationId}/`, messageData);
    };

    // Get single message
    static getMessage = (msgId) => {
        return axiosInstanceWithToken.get(`/message/${msgId}/`);
    };

    // Update single message
    static updateMessage = (msgId, messageData) => {
        return axiosInstanceWithToken.put(`/message/${msgId}/`, messageData);
    };

    // Delete single message
    static deleteMessage = (msgId) => {
        return axiosInstanceWithToken.delete(`/message/${msgId}/`);
    };

    // Get message category list
    static getMessageCategory = () => {
        return axiosInstanceWithToken.get(`/message/category/`);
    };

    // Send Message Item 
    static postMessageSentItem = (messageData) => {
        return axiosInstanceWithToken.post(`/message/sent/`, messageData);
    };

    // Get Unread Messages 
    static getUnreadMessages = () => {
        return axiosInstanceWithToken.get(`/message/sent/`);
    };

    // Update Unread Messages 
    static putUnreadMessages = () => {
        return axiosInstanceWithToken.put(`/message/sent/`, {});
    };

    
    // craete record map 
    // get Record mapping
    static craeteRecordMapping = (agencyLocation, recordMapping) => {
        return axiosInstanceWithToken.post(
            `/record_mapping/create_view/${agencyLocation}/`, recordMapping,);
    };

    
    // get Record mapping
    static getRecordMapping = (agencyLocation) => {
        return axiosInstanceWithToken.get(`/record_mapping/create_view/${agencyLocation}/`);
    };

    // update Record mapping
    // change agency location to id 
    static setRecordMapping = (id, recordMapping) => {
        return axiosInstanceWithToken.put(
            `/record_mapping/${id}/`, recordMapping,
        );
    };

    // delete record map
    static deleteRecordMapping = (id, recordMapping) => {
        return axiosInstanceWithToken.delete(
            `/record_mapping/${id}/`
        );
    };



    // upload file and import data to db
    static uploadFile = (agencyLocation, uploadFile) => {
        return axiosInstanceWithToken.post(`/import_records/${agencyLocation}/`, uploadFile);
    };

    // get staff data list 
    static getStaffDataList = (userId, active=1, page=1) => {
        return axiosInstanceWithToken.get(
            `/staff_data/list/${userId}/?active=${active}&page=${page}`
        );
    };

    // update staff data i.e, delete/recover data
    static updateStaffDataList = (userId, requsetObj) => {
        return axiosInstanceWithToken.put(
            `/staff_data/list/${userId}/`, requsetObj
        );
    };

    // update staff data i.e, delete/recover data
    static getCorrectionDataList = (userId) => {
        return axiosInstanceWithToken.get(`/correction/request/list/${userId}/`);
    };
}


// WEBPACK FOOTER //
// ./src/services/StaffDataService.js